import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { CheckCircle, XCircle, Clock, FileText } from 'lucide-react';

interface MetricsOverviewProps {
  totalRuns: number;
  successRate: number;
  avgSourcesFound: number;
  avgExecutionTime: number;
}

export function MetricsOverview({
  totalRuns,
  successRate,
  avgSourcesFound,
  avgExecutionTime,
}: MetricsOverviewProps) {
  const metrics = [
    {
      title: 'Total Kjøringer',
      value: totalRuns,
      icon: FileText,
      color: 'text-primary',
    },
    {
      title: 'Suksessrate',
      value: `${successRate.toFixed(1)}%`,
      icon: CheckCircle,
      color: 'text-green-600',
    },
    {
      title: 'Snitt kilder funnet',
      value: avgSourcesFound.toFixed(1),
      icon: FileText,
      color: 'text-blue-600',
    },
    {
      title: 'Snitt kjøretid',
      value: `${(avgExecutionTime / 1000).toFixed(1)}s`,
      icon: Clock,
      color: 'text-orange-600',
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {metrics.map((metric) => {
        const Icon = metric.icon;
        return (
          <Card key={metric.title}>
            <CardHeader className="flex flex-row items-center justify-between space-y-0 pb-2">
              <CardTitle className="text-sm font-medium">{metric.title}</CardTitle>
              <Icon className={`h-4 w-4 ${metric.color}`} />
            </CardHeader>
            <CardContent>
              <div className="text-2xl font-bold">{metric.value}</div>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
}
